module.exports = __webpack_public_path__ + "static/media/1001060TL.300bd291.jpg";